import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import * as actions from 'actions';

import moment from "moment";
import _ from "lodash";

import withStyles from "@material-ui/core/styles/withStyles";

// material-ui icons
import Assignment from "@material-ui/icons/Assignment";


// core components
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";


import Form02_04Style from "assets/jss/material-dashboard-pro-react/views/form02_04Style.jsx";

import defaultAvatar from "assets/img/placeholder.jpg";

import { sumScores } from "components/Form/helper";

import ReactTable from "react-table";
import { reactTableDefaultProps } from 'helpers/reactTable';
import { dementiaRiskCheckWithEducationLevel } from 'components/Form/helper';
import { educationLevelDescription } from 'components/Form/helper';


export class Form02_04 extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);
    const { uid, name, profile_image_url = "", gender, birthday: rawBirthday } = this.props.location.state.gradedPerson;
    const birthday = rawBirthday.constructor.name !== "String"
      ? moment(birthday?.toDate())
      : moment(rawBirthday);

    const docs = this.props.doc[uid].map(doc => doc.data()).filter(doc => doc.form.sku === 'form02_03');

    this.state = {
      docs: _.orderBy(docs, ['created_at'], ['desc']),
      user_id: this.props.location.state.gradedPerson.uid,
      org_id: this.props.location.state.org_id,
      uid,
      name,
      profile_image_url,
      gender,
      birthday,
    }
  }

  componentDidMount() {
    const { org_id, user_id } = this.state;
    if (!this.unsubscribe) {
      this.unsubscribe = this.props.getDocsOfMemberAction(org_id, user_id);
    }
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  renderHeader1 = () => {
    const { classes } = this.props;
    const { uid, name, profile_image_url = "", gender, birthday } = this.state;

    return <React.Fragment>
      <GridContainer xs={12} sm={6} className={`${classes.border} ${classes.flexCenter}`}>
        <img className={classes.circle} src={profile_image_url.length === 0 ? defaultAvatar : profile_image_url} alt="등급자 프로필" />
        <GridItem className={classes.title}>
          {name}
        </GridItem>
        <GridItem>
          {gender === 0 ? "여" : "남"}
        </GridItem>
        <GridItem>
          {`${moment().diff(birthday, 'years')}세`}
        </GridItem>
      </GridContainer>
      <GridContainer xs={12} sm={6} className={`${classes.border} ${classes.flexCenter}`}>
        <GridItem>
          작성일: {`${moment().format("YYYY-MM-DD")}`}
        </GridItem>
        <GridItem>
          작성자: {this.props.currentUser.displayName}
        </GridItem>
      </GridContainer>
    </React.Fragment>
  }

  renderTable = () => {
    const { docs } = this.state;
    console.log("docs = ", docs);
    return <ReactTable
      data={docs}
      columns={[
        {
          id: 'created_at',
          Header: '시기(평가날짜)',
          accessor: d => {
            const created_at = d.created_at;
            return moment(created_at ? created_at.toDate() : null).format('YYYY-MM-DD')
          }
        },
        {
          id: 'total',
          Header: '총 30점',
          accessor: d => d.score || sumScores(_.get(d.valueState, '간이정신상태검사'))
        },
        {
          id: '교육수준',
          Header: '교육수준',
          accessor: d => {
            const { valueState: { 간이정신상태검사, 사전질문 } } = d;
            const educationLevel = parseInt(사전질문?.사전질문?.교육수준);
            return educationLevelDescription(educationLevel);
          }
        },
        {
          id: '평가',
          Header: '평가',
          accessor: d => {
            const { valueState: { 간이정신상태검사, 사전질문 } } = d;
            const { gender, age } = d.target;
            const educationYears = parseInt(사전질문?.사전질문?.교육수준);
            const score = sumScores(간이정신상태검사);

            const isRisky = dementiaRiskCheckWithEducationLevel(age, gender, educationYears, score) === true;
            const description = isRisky
              ? "치매의심군"
              : "정상군";
            return description;
          }
        },
        {
          id: 'section1',
          Header: <span>시간지남력<br />총 5점</span>,
          accessor: d => {
            const { valueState } = d;
            return sumScores(_.get(valueState, '간이정신상태검사.시간지남력'));
          }
        },
        {
          id: 'section2',
          Header: <span>장소지남력<br />총 5점</span>,
          accessor: d => {
            const { valueState } = d;
            return sumScores(_.get(valueState, '간이정신상태검사.장소지남력'));
          }
        },
        {
          id: 'section3',
          Header: <span>주의집중력<br />총 5점</span>,
          accessor: d => {
            const { valueState } = d;
            return sumScores(_.get(valueState, '간이정신상태검사.주의집중력'));
          }
        },
        {
          id: 'section4',
          Header: <span>기억력(기억등록, 기억회상)<br />총 6점</span>,
          accessor: d => {
            const { valueState } = d;
            return sumScores(_.get(valueState, '간이정신상태검사.기억등록')) + sumScores(_.get(valueState, '간이정신상태검사.기억회상'));
          }
        },
        {
          id: 'section5',
          Header: <span>언어력<br />총 3점</span>,
          accessor: d => {
            const { valueState } = d;
            return sumScores(_.get(valueState, '간이정신상태검사.따라말하기(언어력)')) + sumScores(_.get(valueState, '간이정신상태검사.이름대기(언어력)'));
          }
        },
        {
          id: 'section6',
          Header: <span>명령실행<br />총 3점</span>,
          accessor: d => {
            const { valueState } = d;
            return sumScores(_.get(valueState, '간이정신상태검사.명령실행'));
          }
        },
        {
          id: 'section7',
          Header: <span>구성능력<br />있음 1점, 없음 0</span>,
          accessor: d => {
            const { valueState } = d;
            return sumScores(_.get(valueState, '간이정신상태검사.구성능력'));
          }
        },
        {
          id: 'section8',
          Header: <span>이해판단력<br />총 2점</span>,
          accessor: d => {
            const { valueState } = d;
            return sumScores(_.get(valueState, '간이정신상태검사.이해판단'));
          }
        },
      ]}
      {...reactTableDefaultProps}
      filterable={false}
      sortable={false}
    />
  }

  render() {
    const { classes } = this.props;

    return (
      <GridContainer xs={12} spacing={2}>
        {this.renderHeader1()}
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>인지기능 영역별 기록지 (서식2-4)</h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12}>
                  {this.renderTable()}
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    )
  }
}

const mapStateToProps = (state) => ({
  currentUser: state.auth.currentUser,
  currentOrg: state.org.currentOrg,
  doc: state.doc,
  // currentGroup: state.
})

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(actions, dispatch);
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(Form02_04Style),
)(Form02_04);
